import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import { install } from "@twind/core";
import config from "./twind.config.js";

// ✅ Initialize Twind before rendering
install(config);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
